import { colors, fontSizes } from "@/app/constants/styles";
import { StyleSheet, ViewStyle, TextStyle } from "react-native";

type RemoveItemStyles = {
  buttonContainer: ViewStyle;
  button: ViewStyle;
  removeText: TextStyle;
};

type EditItemStyles = {
  backdrop: ViewStyle;
  listContainer: ViewStyle;
  listContentContainer: ViewStyle;
  bottomContainer: ViewStyle;
  updateAllContainer: ViewStyle;
  updateAllButtonText: TextStyle;
};

export const removeItemStyles = StyleSheet.create<RemoveItemStyles>({
  buttonContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  button: {
    flex: 1,
    borderWidth: 1,
    borderRadius: 8,
    backgroundColor: colors.cedar,
    borderColor: colors.albaikRed,
    padding: 15,
  },
  removeText: {
    flex: 1,
    color: colors.white,
  },
});

export const editItemStyles = StyleSheet.create<EditItemStyles>({
  backdrop: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  listContainer: {
    marginLeft: "70%",
    width: "100%",
  },
  listContentContainer: {
    flexDirection: "row",
    paddingRight: "50%",
  },
  bottomContainer: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.lightBrown,
    marginTop: 5,
    marginRight: 20,
  },
  updateAllContainer: {
    backgroundColor: colors.albaikBrightRed,
    borderRadius: 8,
    margin: 5,
    padding: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  updateAllButtonText: {
    fontSize: fontSizes.x12,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
  },
});

type EditTposItemStyles = {
  header: ViewStyle;
  aboutContainer: ViewStyle;
  bottomContainer: ViewStyle;
  customiseButtonDisabledContainer: ViewStyle;
  customiseButtonContainer: ViewStyle;
  customiseButtonText: TextStyle;
  quantityLayoutContainer: ViewStyle;
  quantityButtonContainer: ViewStyle;
  buttonItemContainer: ViewStyle;
  editButtonContainer: ViewStyle;
  updateButtonContainer: ViewStyle;
  updateButtonText: TextStyle;
};

type EditIndividualStyles = EditTposItemStyles & {
  container: ViewStyle;
};

const editTposItemStyles: EditTposItemStyles = {
  header: {
    flex: 1,
    marginBottom: 30,
  },
  aboutContainer: {
    marginBottom: 20,
  },
  bottomContainer: {
    flex: 5,
    justifyContent: "flex-end",
    paddingBottom: 20,
  },
  customiseButtonDisabledContainer: {
    flex: 0,
    padding: 10,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.whiteAlpha(0.25),
  },
  customiseButtonContainer: {
    flex: 0,
    padding: 10,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.dullWhite,
  },
  customiseButtonText: {
    fontSize: fontSizes.x12,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.cedar,
  },
  quantityLayoutContainer: {
    marginTop: 15,
    marginBottom: 15,
    alignItems: "center",
    flexDirection: "row",
  },
  quantityButtonContainer: {
    flex: 1,
  },
  buttonItemContainer: {
    flex: 2,
    paddingHorizontal: 10,
    justifyContent: "center",
  },
  editButtonContainer: {
    paddingVertical: 15,
  },
  updateButtonContainer: {
    paddingVertical: 15,
    backgroundColor: colors.albaikRed,
  },
  updateButtonText: {
    color: colors.white,
  },
};

type EditAllStyles = EditTposItemStyles & {
  header: ViewStyle;
  aboutContainer: ViewStyle;
  removeButtonContainer: ViewStyle;
  container: ViewStyle;
};

export const editAllStyles = StyleSheet.create<EditAllStyles>({
  ...editTposItemStyles,
  header: {
    flex: 1,
    flexDirection: "row",
  },
  aboutContainer: {
    flex: 3,
  },
  removeButtonContainer: {
    flex: 2,
  },
  container: {
    flex: 1,
    minWidth: "50%",
    marginVertical: "5%",
    paddingHorizontal: "5%",
    borderColor: colors.cedar30,
    borderWidth: 1,
    borderRadius: 10,
    backgroundColor: colors.cedar,
  },
});

export const editIndividualStyles: EditIndividualStyles = StyleSheet.create({
  container: {
    flex: 1,
    marginRight: 20,
    paddingTop: 20,
    borderColor: colors.cedar30,
    borderWidth: 1,
    minWidth: 450,
    maxWidth: 500,
    borderRadius: 10,
    paddingHorizontal: 10,
    backgroundColor: colors.cedar,
  },
  ...editTposItemStyles,
});

export const placeOrderStyles = StyleSheet.create({
  container: {
    paddingBottom: 5,
  },
  button: {
    flex: 0,
    backgroundColor: colors.albaikRed,
    alignItems: "center",
    height: 50,
    borderRadius: 8,
    justifyContent: "space-between",
    paddingHorizontal: 10,
    flexDirection: "row",
  },
  disabledButton: {
    opacity: 0.5,
  },
  totalContainer: {
    flexDirection: "column",
    alignItems: "flex-end",
  },
  totalText: {
    fontSize: fontSizes.x8,
    color: colors.white,
  },
  buttonText: {
    fontSize: fontSizes.x12,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
  },
});

export const circularButtonStyles = StyleSheet.create({
  buttonContainer: {
    flex: 1,
    height: 55,
    width: 55,
    borderRadius: 8,
    backgroundColor: colors.albaikBrightRed,
    alignItems: "center",
    justifyContent: "center",
  },
  buttonText: {
    fontSize: 26,
    width: 34,
    textAlign: "center",
    color: colors.white,
  },
});

export const productAmountstyles = StyleSheet.create({
  container: {
    flex: 1,
  },
  amountText: {
    alignSelf: "center",
    marginBottom: 10,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.maroon,
    fontSize: fontSizes.x14,
  },
  quantityContainer: {
    alignItems: "center",
    flexDirection: "row",
  },
  quantityTextContainer: {
    flex: 1,
  },
  quantityText: {
    fontSize: fontSizes.x16,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
    textAlign: "center",
  },
});

export const aboutProductStyles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
  },
  titleContainer: {
    flexDirection: "row",
  },
  itemTitle: {
    color: colors.white,
    flexWrap: "wrap",
    textAlign: "left",
    fontSize: 22,
    fontFamily: "HelveticaNeue-Medium",
    letterSpacing: 0,
  },
});
